import React from 'react'

import { useBrandAccountId } from '../useBrandAccountId'

export const useArchivedDocumentImagesInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () =>
      [
        'DocumentImageArchiveListPage_DocumentImages',
        { brandAccountId },
      ] as const,
    [brandAccountId],
  )
}
